import React from 'react'

export default () => (
  <svg viewBox="0 0 8 8">
    <path fillRule="evenodd" clipRule="evenodd" d="M8 4.25H4.25V8h-.5V4.25H0v-.5h3.75V0h.5v3.75H8v.5z"/>
  </svg>
)
